import { ApiRequest } from '@/hooks/api';

export interface ChatConversationResponse {
	conversation_id: string;
	initial_message: string;
}

export interface ChatMessageResponse {
	user_message: string;
	ai_response: string;
}

export class ChatService {
	private apiRequest: ApiRequest;

	constructor(apiRequest: ApiRequest) {
		this.apiRequest = apiRequest;
	}

	async createConversation(journalId: string): Promise<ChatConversationResponse> {
		const response = await this.apiRequest<ChatConversationResponse>({
			endpoint: `v2/nvision/journal/${journalId}/chat/conversation`,
			method: 'POST',
		});

		return response.data;
	}

	async sendMessage(journalId: string, content: string): Promise<ChatMessageResponse> {
		const response = await this.apiRequest<ChatMessageResponse>({
			endpoint: `v2/nvision/journal/${journalId}/chat/message`,
			method: 'POST',
			body: {
				content,
			},
		});

		return response.data;
	}
}
